import { Navigate } from "react-router-dom";

// ─── Per-system route slices ──────────────────────────────────────────────────
import { authPublicRoutes } from "./Components/AuthRoutes";
import { coreRoutes } from "./Components/CoreRoutes";

import { dmsRoutes } from "./Components/DMSRoutes";
import { fmsRoutes } from "./Components/FMSRoutes";
import { othersPublicRoutes } from "./Components/OthersRoutes";

// ─── Assembled route tables ───────────────────────────────────────────────────
export var authProtectedRoutes = [
    ...coreRoutes,
    ...fmsRoutes,
    ...dmsRoutes,

    // Catch-alls — must stay last
    { path: "/", exact: true, component: <Navigate to="/dms/dashboard" /> },
    { path: "*", component: <Navigate to="/pages-coming-soon" /> },
];

export var publicRoutes = [
    ...authPublicRoutes,
    ...othersPublicRoutes,
];